import * as React from 'react';
import { auth } from '../util/auth';
import { IRouterContext } from '../types';

const MenuItem = ({active, url, title, children, onClick}: { active: boolean, url: string, title: string, children?: any, onClick?: () => void }) => (
  <li className={active ? 'active' : ''}>
    {onClick ? (
      <a href={url} title={title} onClick={(e) => { e.preventDefault(); onClick(); }}>{children}</a>
    ) : (
      <a href={url} title={title}>{children}</a>
    )}
  </li>
);

interface IMenuProps {
  name: string;
}

interface IMenuState {
  isAuthenticated: boolean;
  username: string | null;
}

export default class Menu extends React.Component<IMenuProps, IMenuState> {
  context: IRouterContext;
  private interval: any;

  static contextTypes = {
    router: React.PropTypes.object.isRequired
  };

  constructor(props: IMenuProps) {
    super(props);
    this.state = {
      isAuthenticated: auth.isAuthenticated(),
      username: auth.getUsername()
    };
    this.handleLogout = this.handleLogout.bind(this);
  }

  componentDidMount() {
    // Check auth state periodically
    this.checkAuth();
    // Check auth state when component updates (e.g., after login)
    this.interval = setInterval(() => {
      this.checkAuth();
    }, 1000);
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  checkAuth() {
    this.setState({
      isAuthenticated: auth.isAuthenticated(),
      username: auth.getUsername()
    });
  }

  handleLogout() {
    // Call logout endpoint
    fetch('http://localhost:9966/petclinic/api/logout', {
      method: 'POST',
      credentials: 'include'
    }).catch(() => {
      // Ignore errors - clear local state anyway
    }).finally(() => {
      // Clear local auth state
      auth.clearAuth();
      this.setState({
        isAuthenticated: false,
        username: null
      });
      // Redirect to login page
      this.context.router.push({
        pathname: '/login'
      });
    });
  }

  render() {
    const { name } = this.props;
    const { isAuthenticated, username } = this.state;

    return (
      <nav className='navbar navbar-default' role='navigation'>
        <div className='container'>
          <div className='navbar-header'>
            <a className='navbar-brand' href='/'><span></span></a>
            <button type='button' className='navbar-toggle' data-toggle='collapse' data-target='#main-navbar'>
              <span className='icon-bar'></span>
              <span className='icon-bar'></span>
              <span className='icon-bar'></span>
            </button>
          </div>
          <div className='navbar-collapse collapse' id='main-navbar'>
            <ul className='nav navbar-nav navbar-right'>
              <MenuItem active={name === '/'} url='/' title='home page'>
                <span style={{ marginRight: '5px' }} aria-hidden='true'>⌂</span>
                <span>Home</span>
              </MenuItem>

              {isAuthenticated ? <MenuItem active={name.startsWith('/owners')} url='/owners/list' title='find owners'>
                <span style={{ marginRight: '5px' }} aria-hidden='true'>🔍</span>
                <span>Find owners</span>
              </MenuItem> : null}
              {isAuthenticated ? <MenuItem active={name === 'vets'} url='/vets' title='veterinarians'>
                <span style={{ marginRight: '5px' }} aria-hidden='true'>☑</span>
                <span>Veterinarians</span>
              </MenuItem> : null}
              {isAuthenticated ? <MenuItem active={name === 'error'} url='/error'
                title='trigger a RuntimeException to see how it is handled'>
                <span style={{ marginRight: '5px' }} aria-hidden='true'>⚠</span>
                <span>Error</span>
              </MenuItem> : null}

              {isAuthenticated ? (
                <MenuItem active={false} url='#' title='logout' onClick={this.handleLogout}>
                  <span style={{ marginRight: '5px' }} aria-hidden='true'>⇐</span>
                  <span>Logout ({username})</span>
                </MenuItem>
              ) : (
                <MenuItem active={name === '/login'} url='/login' title='login'>
                  <span style={{ marginRight: '5px' }} aria-hidden='true'>→</span>
                  <span>Login</span>
                </MenuItem>
              )}
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}
